var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseButton = function SvgCloseButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231727",
    d: "M4.233 1.448 0 5.071l10.494 11.156-8.378 10.124 4.605 3.806 9.29-9.397 10.861 10.234L30 25.74l-9.204-9.69L30 3.263 26.32 0 16.012 12.244z"
  })));
};
export default SvgCloseButton;